import { render, staticRenderFns } from "./panelNotas.vue?vue&type=template&id=a18bf714&"
import script from "./panelNotas.vue?vue&type=script&lang=js&"
export * from "./panelNotas.vue?vue&type=script&lang=js&"
import style0 from "./panelNotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports